import { ErrorMessage } from '@hookform/error-message';
import PropTypes from 'prop-types';
import React from 'react'
import { Form } from 'react-bootstrap'

// Chebkox input for Sinexiar ECU
// If recives "vertical" attribute, this component align label and checkbox verticaly, otherwise is align in a single line.
export const Checkbox = ( props, context ) => {

    const { label, name, disabled = false, vertical = null, useFormRegister, errors = {} } = props;
    
    return ( 
        
        <Form.Group className="mb-3" controlId={ name }>
            {(vertical)?(
                <>
                    <Form.Label>{ label }</Form.Label>
                    <Form.Check 
                        type="checkbox" 
                        label={ context.t('Enabled') }
                        name={ name } 
                        disabled={ disabled }
                        {...useFormRegister}
                    />
                </>
            ):(
                <>
                    <Form.Check 
                        type="checkbox" 
                        label={ label }
                        name={ name } 
                        disabled={ disabled }
                        {...useFormRegister}
                    />
                </>
            )}
            <ErrorMessage errors={errors} name={name} as={<p className='error-message'/>} />
        </Form.Group>

    )
}

Checkbox.contextTypes = {
    t: PropTypes.func.isRequired
}
export default Checkbox;